'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Examples:
 *
 * <video autoplay loop muted playsinline data-lazy-play>
 *   <source data-lazy-src="${videoUrl}" type="video/mp4">
 * </video>
 *
 * Video element could have data-lazy-play attribute when the video will play/pause automatically when it is on/off screen. data-lazy-play attribute will have a value 'done' right after the video starts playing at the first time.
 */
const OBSERVER_SETTINGS = {
    rootMargin: '100px 0px 100px 0px',
    threshold: 0
};
const loadLazyMedia = function (el) {
    if (el.tagName === 'VIDEO') {
        const sourceEls = el.querySelectorAll('source[data-lazy-src]');
        sourceEls.forEach(sourceEl => {
            if (sourceEl.dataset.lazySrc) {
                sourceEl.setAttribute('src', sourceEl.dataset.lazySrc);
            }
        });
        el.load();
    }
};
const videoCanPlay = function (evt) {
    const el = evt.target;
    el.removeEventListener('canplay', videoCanPlay);
    el.setAttribute('data-lazy-play', 'done');
};
let lazyLoadMedia = {
    init: function () {
        const lazyLoadEls = document.querySelectorAll('[data-lazy-src]');
        const lazyPlayEls = document.querySelectorAll('video[data-lazy-play]');
        console.log('lazyLoadMedia.init()', 'Found ' + lazyLoadEls.length + ' lazy load elements and ' + lazyPlayEls.length + ' lazy play elements.');
        if ('IntersectionObserver' in window) {
            // IntersectionObserver is supported
            //
            // Lazy play observer
            //
            const lazyPlayObserver = new IntersectionObserver(function (entries, _) {
                entries.forEach(entry => {
                    if (entry.isIntersecting && entry.target.offsetParent !== null) {
                        if (entry.target.readyState === 4) {
                            entry.target.play();
                        }
                    }
                    else {
                        entry.target.pause();
                    }
                });
            }, OBSERVER_SETTINGS);
            lazyPlayEls.forEach(el => {
                el.addEventListener('canplay', videoCanPlay);
                lazyPlayObserver.observe(el);
            });
            //
            // Lazy load orserver
            //
            const lazyLoadObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting && entry.target !== null) {
                        loadLazyMedia(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, OBSERVER_SETTINGS);
            lazyLoadEls.forEach(el => {
                lazyLoadObserver.observe((el.tagName === 'SOURCE' ? el.parentNode : el));
            });
        }
        else {
            // IntersectionObserver is NOT supported
            console.log('lazyLoadMedia.init()', 'IntersectionObserver not supported.');
            // Load all instantly
            lazyPlayEls.forEach(el => {
                el.addEventListener('canplay', videoCanPlay);
            });
            lazyLoadEls.forEach(el => {
                loadLazyMedia((el.tagName === 'SOURCE' ? el.parentNode : el));
            });
        }
    }
};
exports.default = lazyLoadMedia;
